<template>
  <section id="" class="section-scc-portal">
    <div class="container">
      <h3>Complete Order</h3>
      <div class="shipping-options  rewards-row">
        <div class="shipping_as_post selected" data-value="shipping_as_post">
          <!-- <img src="./Rewards _ SCC Donor Portal_files/delivery-truck.png">-->
          <span>Post</span>
        </div>
      </div>
      <input type="hidden" name="shipping" id="shipping" value="shipping_as_post">
      <div class="form-group rewards-row" id="wpgv-receipt_email">
        <label>Your email address (for the receipt)</label>
        <input
            type="email"
            name="receipt_email"
            id="receipt_email" class="form-control"
            v-model ="recipient.email"
        >
      </div>
      <div class="form-group  rewards-row" id="wpgv-post_address-title"><label>Shipping address</label></div>
      <div class="form-row  rewards-row" id="wpgv-post_name">
        <div class="row description-row">
          <div class="form-group col-sm-6">
            <input
                type="text"
                id="post_firstname"
                placeholder="First Name"
                class="form-control"
                v-model="recipient.firstName">
          </div>
          <div class="form-group col-sm-6">
            <input
                type="text"
                id="post_lastname"
                placeholder="Last Name"
                class="form-control"
                v-model="recipient.lastName">
          </div>
        </div>
        <div class="form-group col-sm-12 description-row">
          <input
              type="text"
              id="post_address"
              placeholder="Address"
              class="form-control"
              v-model="recipient.address"
          >
        </div>
        <div class="form-group col-sm-12 description-row">
          <input
              type="text"
              id="post_code"
              placeholder="Postcode"
              class="form-control"
              v-model="recipient.zip">
        </div>
      </div>
      <div class="form-group rewards-row" id="wpgv-shipping_method">
        <label id="shipping_method"> Shipping method </label>
        <label data-value="0">
          <input type="radio" name="shipping_method" value="Free" class="radio-field"> Free
        </label>
      </div>
      <div class="order_details_preview rewards-row">
        <h3>Your Order</h3>
        <div class="wpgv_preview_box order-row">
          <div>
            <h4 class="wpgv-itemtitle">{{ selectedRewards.name }}</h4>
            <span>Your Name: <i id="autoyourname"></i> {{ recipient.firstName }} {{ recipient.lastName }}</span>
          </div>
          <div id="itemprice"> <span></span> {{ selectedRewards.points }} POINTS</div>
        </div>selectedRewards.name
        <div class="wpgv_shipping_box order-row">
          <div>
            <h4>Complete Order</h4>
          </div>
          <div id="shippingprice"> <span>{{ selectedRewards.points }}</span> POINTS</div>
        </div>

        <div class="wpgv_total_box order-row">
          <div>
            <h4><b>Total</b></h4>
          </div>
          <div id="totalprice"><b> <span>{{ selectedRewards.points }}</span> POINTS</b></div>
        </div>
      </div>
      <div id="order-confirmation" class="rewards-row">
        <div class="form-group rewards-row" id="wpgv_payment_gateway">
          <label>Payment Method</label>
          <select name="payemnt_gateway" id="payemnt_gateway" class="form-control"><option value="Points">Points</option></select>
        </div>
        <div class="form-group rewards-row">
          <label>
            <input
                type="checkbox"
                class="required"
                name="acceptVoucherTerms"
                v-model="checkTermsAndCondition"
            >
              {{ termsAndCondition }}
<!--            I hereby accept the terms and conditions, the revocation of the privacy policy and confirm that all information is correct.-->
          </label>
        </div>
        <div class="voucherNote rewards-row"><!--Note: Your order will be processed during next 24 hours--> {{rewardTermsNote}}</div>
        <div class="wpgv-buttons rewards-row">
          <button
              type="button"
              class="btn button-section"
              @click="actionBack"
          >
            Back
          </button>
          <button
              type="button"
              data-next="step4"
              class="btn button-section"
              v-on:click="createOrder"
          >
            Pay Now -  <span></span> POINTS
          </button>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
import {mapState} from "vuex";
//import rwPaymentSuccessful from "./rwPaymentSuccessful";

export default {
  name: "rwOrder",
  data(){
    return {
      checkTermsAndCondition: false,
      recipient: {
        firstName: '',
        lastName: '',
        address: '',
        zip: '',
        email: '',
      }
    }
  },
  computed : {
    ...mapState({
      order: state => state.rewards.order,
      selectedRewards: state => state.rewards.selectedRewards,
      donorZipCode: state => state.donorInformation.zipCode,
      donorStreet: state => state.donorInformation.street,
      donorCity: state => state.donorInformation.city,
      donorState: state => state.donorInformation.state,
      donorCountry: state => state.donorInformation.country,
      donorEmail: state => state.donorInformation.email,
      termsAndCondition: state => state.rewards.rewardsSettings.termsAndCondition,
      rewardTermsNote: state => state.rewards.rewardsSettings.rewardTermsNote,
    })
  },
  created() {
    this.recipient.firstName = this.order.donorFirstName
    this.recipient.lastName = this.order.donorLastName

    this.recipient.address  = this.recipient.address + this.donorStreet===''?'':this.donorStreet + ', '
                            + this.this.donorCity===''?'':this.donorCity + ', '
                            + this.donorCity===''?'':this.donorCity + ', '
                            + this.donorZipCode===''?'':this.donorZipCode

    this.recipient.zip = this.donorZipCode
    this.recipient.email = this.donorEmail
  },
  methods: {
    actionBack(){
      this.$router.push({ name: 'rwDescriptionOrder' })
    },
    async createOrder(){
      if(!this.checkTermsAndCondition){
        this.errorAlert('Please accept the terms and conditions')
        return
      }
      this.$root.$emit("showSpinner");
      this.$store.commit('rewards/set_order', {recipientEmail: this.recipient.email})
      // eslint-disable-next-line no-unused-vars
      const resCreateOrder = await this.$store.dispatch('rewards/SET_setRewardsOrder')

      this.$root.$emit("hideSpinner");

      this.$router.push({ name: 'rwPaymentSuccessful' })
//      this.$router.push({ name: 'dbChoiceDonationLocation' })
    },
    errorAlert(message){
      this.$root.$emit('messageBox',
        {
          timeShow: 0,
          typeColor: "danger",
          textMessage: message,
        })
    },
  }

}
</script>
<style>
  .wpgv-buttons {
    padding-bottom: 20px;
    display: flex;
    align-items: baseline;
    justify-content: space-between;
  }
  .wpgv-buttons .next-button,
  .wpgv-buttons #paynowbtn {
    background: #c9c76d;
    color: #fff;
    border-radius: 5px;
    box-sizing: border-box;
    line-height: 1;
    font-size: 20px;
    margin-bottom: 10px;
    cursor: pointer;
    border: 0;
    padding: 10px;
    outline: 0;
    box-shadow: 0 0 2px 0px rgba(0, 0, 0, 0.2);
  }
  .wpgv-buttons .next-button:after,
  .wpgv-buttons #paynowbtn:after {
    content: "";
    border: solid #fff;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 3px;
    transform: rotate(-45deg);
    vertical-align: middle;
    margin-left: 3px;
  }
  .btn:hover {
    color: #212529;
  }
  .wpgv-buttons .back-button {
    cursor: pointer;
    font-size: 1.2em;
  }
  .rewards-row{
    max-width: 560px;
    margin: 10px 0 0 0;
  }
  </style>
  <style scoped>
  .wpgv-receipt_email{
    display: flex;
    flex-direction: column;
  }
  .description-row{
    margin-bottom: 5px;
  }
  #wpgv-receipt_email{
    display: flex;
    flex-direction: column;
  }
  .order_details_preview{
    background-color: #adb5bd24;
    padding: 0 15px;
  }
  #order-confirmation{
    background-color: #adb5bd75;
    padding: 0 15px;
  }

  .order-row{
    display: flex;
    justify-content: space-between;
  }
</style>
